/**
 * Imports both the basis and the component styles as well as the default theme
 * Remember to provide a wrapper element with the scope class and "dnb-core-style".
 * You can do that by using the shared Provider with the `scopeHash="auto"` property.
 */

import './dnb-ui-basis--isolated.min.css'
import './themes/theme-ui/ui-theme-components--isolated.min.css'
import './themes/theme-ui/ui-theme-basis--isolated.min.css'
